import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

import { SidebarNavHelper } from '../app-sidebar-nav.service';
import { INavData } from '../app-sidebar-nav';
import { AppService } from 'src/modules/base/shared/services/app.service';
import { TranslateService } from 'src/modules/base/services/translate.service';

@Component({
    selector: 'app-sidebar-nav-link-content, cui-sidebar-nav-link-content',
    template: `
    @if (true) {
      <sidebar-nav-icon-img [item]="item"></sidebar-nav-icon-img>
      <ng-container>{{item | translate_menu | async}} </ng-container>
      @if (helper.hasBadge(item)) {
        <span [ngClass]="item | appSidebarNavBadge">{{ item.badge.text }}</span>
      }
    }
    `,
    providers: [SidebarNavHelper],
    standalone: false
})
export class AppSidebarNavLinkContentComponent {
  @Input() item: any;


  constructor(
    public helper: SidebarNavHelper,
    public translateService: TranslateService
  ) { }

}

@Component({
    selector: 'sidebar-nav-icon-img',
    template: `
    @if (helper.hasIconImg(item)) {
      <img [src]="'assets/images/icons/'+item.icon_name" class="nav-icon nav-img-icon" >
    } @else {
      @if (helper.hasIcon(item)) {
        <i [ngClass]="item | appSidebarNavIcon"></i>
      }
    }
    `,
    providers: [SidebarNavHelper],
    standalone: false
})
export class AppSidebarNavIconImg {
  @Input() item: any;

  constructor(
    public helper: SidebarNavHelper
  ) { }
}




@Component({
    selector: 'app-sidebar-nav-link, cui-sidebar-nav-link',
    templateUrl: './app-sidebar-nav-link.component.html',
    providers: [SidebarNavHelper],
    standalone: false
})
export class AppSidebarNavLinkComponent implements OnInit, OnDestroy {

  protected _item: INavData;

  protected finalUrl: String = '';
  @Input()
  set item(item: INavData) {
    this._item = JSON.parse(JSON.stringify(item));
  }
  get item(): INavData {
    return this._item;
  }

  @Output() linkClick = new EventEmitter();

  public linkType: string;
  public href: string;
  //public linkActive: boolean;
  private url: string;

  private navigationEndObservable: Observable<NavigationEnd>;
  private navSubscription: Subscription;

  constructor(
    public router: Router,
    public appService: AppService,
  ) {
    this.navigationEndObservable = router.events.pipe(
      filter(event => {
        return event instanceof NavigationEnd;
      })
    ) as Observable<NavigationEnd>;
  }

  ngOnInit() {

    //this.linkActive = false;
    if (this.item.url == undefined) {
      this.item.url = '/' + this.item.id;
    } else {
      var urlTree = this.router.parseUrl(this.item.url.toString());
      if (this.item.linkProps == undefined) {
        this.item.linkProps = {};
        if (this.item.linkProps.queryParams == undefined) {
          this.item.linkProps.queryParams = {};
        }
      }

      this.item.linkProps.queryParams = { ...urlTree.queryParams, ...this.item.linkProps.queryParams };
      this.finalUrl = '/' + this.item.url.toString().split("?")[0];
    }
    this.url = typeof this.item.url === 'string' ? this.item.url : this.router.serializeUrl(this.router.createUrlTree(this.item.url));
    this.linkType = this.getLinkType();
    this.href = this.isDisabled() ? '' : (this.item.href || this.linkType == 'external' ? this.url : '/' + this.url);
    // this.linkActivate(this.router.url.split(/[?#(;]/)[0].split('/'));
    // this.navSubscription = this.navigationEndObservable.subscribe(event => {
    //   this.linkActive = false;
    //   this.linkActivate(event.urlAfterRedirects.split(/[?#(;]/)[0].split('/'));
    // });
  }

  // linkActivate(urlArray: string[]) {
  //   const itemUrlArray = this.href.split(/[?#(;]/)[0].split('/');
  //   urlArray.forEach(element => {
  //     if (element != "" && element !="account-management") {
  //       const index = itemUrlArray.findIndex(x => x == element);
  //       if (index != -1)
  //         //this.linkActive = true;
  //     }
  //   });
  // }

  ngOnDestroy(): void {
    // this.navSubscription.unsubscribe();
  }

  public getLinkType() {
    return this.isDisabled() ? 'disabled' : this.isExternalLink() ? 'external' : 'link';
  }

  public isDisabled() {
    return (this.item.attributes && this.item.attributes.disabled) ? true : null;
  }

  public isExternalLink() {
    return !!this.item.href || this.url.substring(0, 4) === 'http' || this._item.isExternal != undefined && this._item.isExternal;
  }

  linkClicked() {
    this.linkClick.emit();
  }
}
